import React from 'react';

// Styles
import styles from './info.module.css'

const teamNameById = {
    "44": "BOSTON BRUINS",
    "45": "BUFFALO SABRES",
    "46": "CALGARY FLAMES",
    "47": "CAROLINA HURRICANES",
    "48": "CHICAGO BLACKHAWKS",
    "49": "COLORADO AVALANCHE",
    "50": "COLUMBUS BLUE JACKETS",
    "51": "DALLAS STARS *ENLARGE IMAGE",
    "52": "DETROIT RED WINGS",
    "53": "EDMONTON OILERS",
    "54": "FLORIDA PANTHERS",
    "55": "LOS ANGELES KINGS",
    "56": "MINNESOTA WILD",
    "57": "MONTREAL CANADIENS",
    "58": "NASHVILLE PREDATORS *ENLARGE IMAGE",
    "59": "NEW JERSEY DEVILS",
    "60": "NEW YORK ISLANDERS",
    "61": "OTTAWA SENATORS",
    "62": "PHILADELPHIA FLYERS",
    "63": "UTAH",
    "64": "PITTSBURGH PENGUINS",
    "65": "SAN JOSE SHARKS",
    "66": "ST. LOUIS BLUES",
    "67": "TAMPA BAY LIGHTNING",
    "68": "TORONTO MAPLE LEAFS",
    "69": "VANCOUVER CANUCKS",
    "70": "WASHINGTON CAPITALS",
    "73": "NEW YORK RANGERS",
    "142": "WINNIPEG JETS",
    "163": "SEATTLE KRAKEN *ENLARGE IMAGE"
}

const jerseyTypeById = {
    "393": "DARK 25/26",
    "394": "WHITE 25/26",
    "395": "WHITE 25/26",
    "396": "DARK 25/26",
    "397": "DARK 25/26",
    "398": "ALT 24/25",
    "401": "DARK 25/26",
    "402": "WHITE 25/26",
    "403": "DARK 25/26",
    "404": "WHITE 25/26",
    "405": "DARK 25/26",
    "406": "WHITE 25/26",
    "409": "DARK 25/26",
    "410": "WHITE 25/26",
    "417": "DARK 25/26",
    "419": "WHITE 25/26",
    "420": "DARK 25/26",
    "421": "WHITE 25/26",
    "422": "DARK 25/26",
    "423": "WHITE 25/26",
    "424": "DARK 25/26",
    "427": "DARK 25/26",
    "428": "WHITE 25/26",
    "429": "DARK 25/26",
    "430": "WHITE 25/26",
    "431": "WHITE 25/26",
    "443": "DARK 25/26",
    "444": "WHITE 25/26",
    "445": "DARK 25/26",
    "446": "WHITE 25/26",
    "485": "DARK 25/26",
    "491": "DARK 25/26",
    "508": "WHITE 25/26",
    "516": "DARK 25/26",
    "527": "WHITE 25/26",
    "531": "DARK 25/26",
    "532": "WHITE 25/26",
    "534": "WHITE 25/26",
    "552": "WHITE 25/26",
    "553": "DARK 25/26",
    "554": "WHITE 25/26",
    "555": "WHITE 25/26",
    "580": "DARK 24/25",
    "581": "WHITE 24/25",
    "582": "DARK 25/26",
    "584": "DARK 25/26",
    "621": "DARK 25/26",
    "622": "WHITE 25/26",
    "625": "WHITE 25/26",
    "626": "DARK 25/26",
    "627": "WHITE 25/26",
    "638": "DARK 25/26",
    "639": "ALT 24/25",
    "640": "ALT 24/25",
    "641": "DARK 25/26",
    "642": "DARK 25/26",
    "643": "ALT 24/25",
    "649": "ALT 24/25",
    "650": "ALT 24/25",
    "651": "ALT 24/25",
    "659": "WHITE 25/26",
    "660": "ALT 24/25",
    "667": "ALT 24/25",
    "700": "DARK 25/26",
    "701": "WHITE 25/26",
    "702": "WHITE 25/26",
    "706": "WHITE 25/26",
    "707": "DARK 25/26",
    "708": "WHITE 25/26",
    "709": "ALT 24/25",
    "710": "ALT 25/26",
    "711": "ALT 24/25",
    "712": "ALT 24/25"
}

const playersById = {
    "13860": {
        "Name": "Swayman",
        "Number": "1",
        "AorC": "          "
    },
    "13861": {
        "Name": "Lohrei",
        "Number": "6",
        "AorC": "          "
    },
    "13862": {
        "Name": "Mittelstadt",
        "Number": "11",
        "AorC": "          "
    },
    "13863": {
        "Name": "Zacha",
        "Number": "18",
        "AorC": "          "
    },
    "13864": {
        "Name": "Beecher",
        "Number": "19",
        "AorC": "          "
    },
    "13865": {
        "Name": "Jokiharju",
        "Number": "20",
        "AorC": "          "
    },
    "13866": {
        "Name": "Peeke",
        "Number": "26",
        "AorC": "          "
    },
    "13867": {
        "Name": "Lindholm",
        "Number": "27",
        "AorC": "          "
    },
    "13868": {
        "Name": "Lindholm",
        "Number": "28",
        "AorC": "          "
    },
    "13869": {
        "Name": "Geekie",
        "Number": "39",
        "AorC": "          "
    },
    "13870": {
        "Name": "Harris",
        "Number": "43",
        "AorC": "          "
    },
    "13871": {
        "Name": "Kastelic",
        "Number": "47",
        "AorC": "          "
    },
    "13872": {
        "Name": "Viel",
        "Number": "48",
        "AorC": "          "
    },
    "13873": {
        "Name": "Kuraly",
        "Number": "52",
        "AorC": "          "
    },
    "13874": {
        "Name": "Korpisalo",
        "Number": "70",
        "AorC": "          "
    },
    "13875": {
        "Name": "Arvidsson",
        "Number": "71",
        "AorC": "          "
    },
    "13876": {
        "Name": "McAvoy",
        "Number": "73",
        "AorC": "          "
    },
    "13877": {
        "Name": "Eyssimont",
        "Number": "81",
        "AorC": "          "
    },
    "13878": {
        "Name": "Jeannot",
        "Number": "84",
        "AorC": "          "
    },
    "13879": {
        "Name": "Pastrnak",
        "Number": "88",
        "AorC": "A         "
    },
    "13880": {
        "Name": "Zadorov",
        "Number": "91",
        "AorC": "          "
    },
    "13881": {
        "Name": "Khusnutdinov",
        "Number": "92",
        "AorC": "          "
    },
    "13882": {
        "Name": "Minten",
        "Number": "93",
        "AorC": "          "
    },
    "13883": {
        "Name": "Petry",
        "Number": "2",
        "AorC": "          "
    },
    "13884": {
        "Name": "Jones",
        "Number": "3",
        "AorC": "          "
    },
    "13885": {
        "Name": "Ekblad",
        "Number": "5",
        "AorC": "          "
    },
    "13886": {
        "Name": "Kulikov",
        "Number": "7",
        "AorC": "          "
    },
    "13887": {
        "Name": "Bennett",
        "Number": "9",
        "AorC": "          "
    },
    "13888": {
        "Name": "Greer",
        "Number": "10",
        "AorC": "          "
    },
    "13889": {
        "Name": "Samoskevich",
        "Number": "11",
        "AorC": "          "
    },
    "13890": {
        "Name": "Gadjovich",
        "Number": "12",
        "AorC": "          "
    },
    "13891": {
        "Name": "Reinhart",
        "Number": "13",
        "AorC": "          "
    },
    "13892": {
        "Name": "Motte",
        "Number": "14",
        "AorC": "          "
    },
    "13893": {
        "Name": "Lundell",
        "Number": "15",
        "AorC": "          "
    },
    "13894": {
        "Name": "Barkov",
        "Number": "16",
        "AorC": "C         "
    },
    "13895": {
        "Name": "Rodrigues",
        "Number": "17",
        "AorC": "          "
    },
    "13896": {
        "Name": "Gregor",
        "Number": "18",
        "AorC": "          "
    },
    "13897": {
        "Name": "Tkachuk",
        "Number": "19",
        "AorC": "          "
    },
    "13898": {
        "Name": "Verhaeghe",
        "Number": "23",
        "AorC": "          "
    },
    "13899": {
        "Name": "Balinskis",
        "Number": "26",
        "AorC": "          "
    },
    "13900": {
        "Name": "Luostarinen",
        "Number": "27",
        "AorC": "          "
    },
    "13901": {
        "Name": "Tarasov",
        "Number": "40",
        "AorC": "          "
    },
    "13902": {
        "Name": "Forsling",
        "Number": "42",
        "AorC": "          "
    },
    "13903": {
        "Name": "Marchand",
        "Number": "63",
        "AorC": "          "
    },
    "13904": {
        "Name": "Boqvist",
        "Number": "70",
        "AorC": "          "
    },
    "13905": {
        "Name": "Kunin",
        "Number": "71",
        "AorC": "          "
    },
    "13906": {
        "Name": "Bobrovsky",
        "Number": "72",
        "AorC": "          "
    },
    "13907": {
        "Name": "Andonovski",
        "Number": "75",
        "AorC": "          "
    },
    "13908": {
        "Name": "Mikkola",
        "Number": "77",
        "AorC": "          "
    },
    "13909": {
        "Name": "Schwindt",
        "Number": "79",
        "AorC": "          "
    },
    "13910": {
        "Name": "Nosek",
        "Number": "92",
        "AorC": "          "
    },
    "13911": {
        "Name": "Geekie",
        "Number": "14",
        "AorC": "          "
    },
    "13912": {
        "Name": "Stachowiak",
        "Number": "19",
        "AorC": "          "
    },
    "13913": {
        "Name": "Paul",
        "Number": "20",
        "AorC": "          "
    },
    "13914": {
        "Name": "Point",
        "Number": "21",
        "AorC": "          "
    },
    "13915": {
        "Name": "Bjorkstrand",
        "Number": "22",
        "AorC": "          "
    },
    "13916": {
        "Name": "Crozier",
        "Number": "24",
        "AorC": "          "
    },
    "13917": {
        "Name": "McDonagh",
        "Number": "27",
        "AorC": "          "
    },
    "13918": {
        "Name": "Girgensons",
        "Number": "28",
        "AorC": "          "
    },
    "13919": {
        "Name": "Holmberg",
        "Number": "29",
        "AorC": "          "
    },
    "13920": {
        "Name": "Johansson",
        "Number": "31",
        "AorC": "          "
    },
    "13921": {
        "Name": "Gourde",
        "Number": "37",
        "AorC": "          "
    },
    "13922": {
        "Name": "Hagel",
        "Number": "38",
        "AorC": "          "
    },
    "13923": {
        "Name": "Chaffee",
        "Number": "41",
        "AorC": "          "
    },
    "13924": {
        "Name": "Raddysh",
        "Number": "43",
        "AorC": "          "
    },
    "13925": {
        "Name": "Sabourin",
        "Number": "46",
        "AorC": "          "
    },
    "13926": {
        "Name": "D'Astous",
        "Number": "51",
        "AorC": "          "
    },
    "13927": {
        "Name": "Duke",
        "Number": "53",
        "AorC": "          "
    },
    "13928": {
        "Name": "Guentzel",
        "Number": "59",
        "AorC": "          "
    },
    "13929": {
        "Name": "Katchouk",
        "Number": "61",
        "AorC": "          "
    },
    "13930": {
        "Name": "Finley",
        "Number": "62",
        "AorC": "          "
    },
    "13931": {
        "Name": "Cirelli",
        "Number": "71",
        "AorC": "          "
    },
    "13932": {
        "Name": "Schmidt",
        "Number": "76",
        "AorC": "          "
    },
    "13933": {
        "Name": "Hedman",
        "Number": "77",
        "AorC": "C         "
    },
    "13934": {
        "Name": "Lilleberg",
        "Number": "78",
        "AorC": "          "
    },
    "13935": {
        "Name": "Cernak",
        "Number": "81",
        "AorC": "          "
    },
    "13936": {
        "Name": "Kucherov",
        "Number": "86",
        "AorC": "          "
    },
    "13937": {
        "Name": "Vasilevskiy",
        "Number": "88",
        "AorC": "          "
    },
    "13938": {
        "Name": "Moser",
        "Number": "90",
        "AorC": "          "
    },
    "13939": {
        "Name": "Goncalves",
        "Number": "93",
        "AorC": "          "
    },
    "13943": {
        "Name": "Gostisbehere",
        "Number": "4",
        "AorC": "          "
    },
    "13944": {
        "Name": "Chatfield",
        "Number": "5",
        "AorC": "          "
    },
    "13945": {
        "Name": "Reilly",
        "Number": "6",
        "AorC": "          "
    },
    "13946": {
        "Name": "Staal",
        "Number": "11",
        "AorC": "C         "
    },
    "13947": {
        "Name": "Miller",
        "Number": "19",
        "AorC": "          "
    },
    "13948": {
        "Name": "Aho",
        "Number": "20",
        "AorC": "          "
    },
    "13949": {
        "Name": "Nikishin",
        "Number": "21",
        "AorC": "          "
    },
    "13950": {
        "Name": "Stankoven",
        "Number": "22",
        "AorC": "          "
    },
    "13951": {
        "Name": "Jarvis",
        "Number": "24",
        "AorC": "          "
    },
    "13952": {
        "Name": "Walker",
        "Number": "26",
        "AorC": "          "
    },
    "13953": {
        "Name": "Ehlers",
        "Number": "27",
        "AorC": "          "
    },
    "13954": {
        "Name": "Carrier",
        "Number": "28",
        "AorC": "          "
    },
    "13955": {
        "Name": "Andersen",
        "Number": "31",
        "AorC": "          "
    },
    "13956": {
        "Name": "Svechnikov",
        "Number": "37",
        "AorC": "          "
    },
    "13957": {
        "Name": "Martinook",
        "Number": "48",
        "AorC": "          "
    },
    "13958": {
        "Name": "Robinson",
        "Number": "50",
        "AorC": "          "
    },
    "13959": {
        "Name": "Kochetkov",
        "Number": "52",
        "AorC": "          "
    },
    "13960": {
        "Name": "Blake",
        "Number": "53",
        "AorC": "          "
    },
    "13961": {
        "Name": "Jaaska",
        "Number": "54",
        "AorC": "          "
    },
    "13962": {
        "Name": "Legault",
        "Number": "62",
        "AorC": "          "
    },
    "13963": {
        "Name": "Hall",
        "Number": "71",
        "AorC": "          "
    },
    "13964": {
        "Name": "Slavin",
        "Number": "74",
        "AorC": "          "
    },
    "13965": {
        "Name": "Jankowski",
        "Number": "77",
        "AorC": "          "
    },
    "13966": {
        "Name": "Kotkaniemi",
        "Number": "82",
        "AorC": "          "
    },
    "13967": {
        "Name": "Pelech",
        "Number": "3",
        "AorC": "          "
    },
    "13968": {
        "Name": "Pulock",
        "Number": "6",
        "AorC": "          "
    },
    "13969": {
        "Name": "Tsyplakov",
        "Number": "7",
        "AorC": "          "
    },
    "13970": {
        "Name": "Holmstrom",
        "Number": "10",
        "AorC": "          "
    },
    "13971": {
        "Name": "Duclair",
        "Number": "11",
        "AorC": "          "
    },
    "13972": {
        "Name": "Barzal",
        "Number": "13",
        "AorC": "          "
    },
    "13973": {
        "Name": "Horvat",
        "Number": "14",
        "AorC": "A         "
    },
    "13974": {
        "Name": "Gatcomb",
        "Number": "16",
        "AorC": "          "
    },
    "13975": {
        "Name": "Engvall",
        "Number": "18",
        "AorC": "          "
    },
    "13976": {
        "Name": "Palmieri",
        "Number": "21",
        "AorC": "          "
    },
    "13977": {
        "Name": "Mayfield",
        "Number": "24",
        "AorC": "          "
    },
    "13978": {
        "Name": "Terry",
        "Number": "25",
        "AorC": "          "
    },
    "13979": {
        "Name": "Lee",
        "Number": "27",
        "AorC": "          "
    },
    "13980": {
        "Name": "Romanov",
        "Number": "28",
        "AorC": "          "
    },
    "13981": {
        "Name": "Drouin",
        "Number": "29",
        "AorC": "          "
    },
    "13982": {
        "Name": "Sorokin",
        "Number": "30",
        "AorC": "          "
    },
    "13983": {
        "Name": "MacLean",
        "Number": "32",
        "AorC": "          "
    },
    "13984": {
        "Name": "Rittich",
        "Number": "33",
        "AorC": "          "
    },
    "13985": {
        "Name": "Boqvist",
        "Number": "34",
        "AorC": "          "
    },
    "13986": {
        "Name": "George",
        "Number": "36",
        "AorC": "          "
    },
    "13987": {
        "Name": "Varlamov",
        "Number": "40",
        "AorC": "          "
    },
    "13988": {
        "Name": "Pageau",
        "Number": "44",
        "AorC": "          "
    },
    "13989": {
        "Name": "Day",
        "Number": "47",
        "AorC": "          "
    },
    "13990": {
        "Name": "Schaefer",
        "Number": "48",
        "AorC": "          "
    },
    "13991": {
        "Name": "Shabanov",
        "Number": "49",
        "AorC": "          "
    },
    "13992": {
        "Name": "Heineman",
        "Number": "51",
        "AorC": "          "
    },
    "13993": {
        "Name": "Kuefler",
        "Number": "52",
        "AorC": "          "
    },
    "13994": {
        "Name": "Cizikas",
        "Number": "53",
        "AorC": "          "
    },
    "13995": {
        "Name": "Berg",
        "Number": "55",
        "AorC": "          "
    },
    "13996": {
        "Name": "Dorrington",
        "Number": "56",
        "AorC": "          "
    },
    "13997": {
        "Name": "Mitton",
        "Number": "62",
        "AorC": "          "
    },
    "13998": {
        "Name": "Ritchie",
        "Number": "64",
        "AorC": "          "
    },
    "13999": {
        "Name": "Nurmi",
        "Number": "72",
        "AorC": "          "
    },
    "14000": {
        "Name": "Bear",
        "Number": "74",
        "AorC": "          "
    },
    "14001": {
        "Name": "Gahagen",
        "Number": "75",
        "AorC": "          "
    },
    "14002": {
        "Name": "DeAngelo",
        "Number": "77",
        "AorC": "          "
    },
    "14003": {
        "Name": "Drew",
        "Number": "81",
        "AorC": "          "
    },
    "14004": {
        "Name": "Rowe",
        "Number": "85",
        "AorC": "          "
    },
    "14005": {
        "Name": "McDonald",
        "Number": "89",
        "AorC": "          "
    },
    "14006": {
        "Name": "McGroarty",
        "Number": "2",
        "AorC": "          "
    },
    "14007": {
        "Name": "St. Ivany",
        "Number": "3",
        "AorC": "          "
    },
    "14008": {
        "Name": "Shea",
        "Number": "5",
        "AorC": "          "
    },
    "14009": {
        "Name": "Kettles",
        "Number": "7",
        "AorC": "          "
    },
    "14010": {
        "Name": "Howe",
        "Number": "9",
        "AorC": "          "
    },
    "14011": {
        "Name": "Hallander",
        "Number": "11",
        "AorC": "          "
    },
    "14012": {
        "Name": "Hayes",
        "Number": "13",
        "AorC": "          "
    },
    "14013": {
        "Name": "Brazeau",
        "Number": "16",
        "AorC": "          "
    },
    "14014": {
        "Name": "Rust",
        "Number": "17",
        "AorC": "          "
    },
    "14015": {
        "Name": "Novak",
        "Number": "18",
        "AorC": "          "
    },
    "14016": {
        "Name": "Dewar",
        "Number": "19",
        "AorC": "          "
    },
    "14017": {
        "Name": "Dumba",
        "Number": "24",
        "AorC": "          "
    },
    "14018": {
        "Name": "Wotherspoon",
        "Number": "28",
        "AorC": "          "
    },
    "14019": {
        "Name": "Blomqvist",
        "Number": "30",
        "AorC": "          "
    },
    "14020": {
        "Name": "Jarry",
        "Number": "35",
        "AorC": "          "
    },
    "14021": {
        "Name": "Silovs",
        "Number": "37",
        "AorC": "          "
    },
    "14022": {
        "Name": "Mantha",
        "Number": "39",
        "AorC": "          "
    },
    "14023": {
        "Name": "Koivunen",
        "Number": "41",
        "AorC": "          "
    },
    "14024": {
        "Name": "Brunicke",
        "Number": "45",
        "AorC": "          "
    },
    "14025": {
        "Name": "Lizotte",
        "Number": "46",
        "AorC": "          "
    },
    "14026": {
        "Name": "Tomasino",
        "Number": "53",
        "AorC": "          "
    },
    "14027": {
        "Name": "Acciari",
        "Number": "55",
        "AorC": "          "
    },
    "14028": {
        "Name": "Letang",
        "Number": "58",
        "AorC": "          "
    },
    "14029": {
        "Name": "Karlsson",
        "Number": "65",
        "AorC": "          "
    },
    "14030": {
        "Name": "Rakell",
        "Number": "67",
        "AorC": "          "
    },
    "14031": {
        "Name": "Malkin",
        "Number": "71",
        "AorC": "          "
    },
    "14032": {
        "Name": "Zonnon",
        "Number": "72",
        "AorC": "          "
    },
    "14033": {
        "Name": "Clifton",
        "Number": "75",
        "AorC": "          "
    },
    "14034": {
        "Name": "Kindel",
        "Number": "81",
        "AorC": "          "
    },
    "14035": {
        "Name": "Jones",
        "Number": "82",
        "AorC": "          "
    },
    "14036": {
        "Name": "Crosby",
        "Number": "87",
        "AorC": "C         "
    },
    "14037": {
        "Name": "Murphy",
        "Number": "5",
        "AorC": "          "
    },
    "14038": {
        "Name": "Rinzel",
        "Number": "6",
        "AorC": "          "
    },
    "14039": {
        "Name": "Donato",
        "Number": "8",
        "AorC": "          "
    },
    "14040": {
        "Name": "Dickinson",
        "Number": "16",
        "AorC": "          "
    },
    "14041": {
        "Name": "Foligno",
        "Number": "17",
        "AorC": "C         "
    },
    "14042": {
        "Name": "Anderson",
        "Number": "22",
        "AorC": "          "
    },
    "14043": {
        "Name": "Lafferty",
        "Number": "24",
        "AorC": "          "
    },
    "14044": {
        "Name": "Burakovsky",
        "Number": "28",
        "AorC": "          "
    },
    "14045": {
        "Name": "Knight",
        "Number": "30",
        "AorC": "          "
    },
    "14046": {
        "Name": "Dach",
        "Number": "34",
        "AorC": "          "
    },
    "14047": {
        "Name": "Del Mastro",
        "Number": "38",
        "AorC": "          "
    },
    "14048": {
        "Name": "Brossoit",
        "Number": "39",
        "AorC": "          "
    },
    "14049": {
        "Name": "Soderblom",
        "Number": "40",
        "AorC": "          "
    },
    "14050": {
        "Name": "Kaiser",
        "Number": "44",
        "AorC": "          "
    },
    "14051": {
        "Name": "Crevier",
        "Number": "46",
        "AorC": "          "
    },
    "14052": {
        "Name": "Grzelcyk",
        "Number": "48",
        "AorC": "          "
    },
    "14053": {
        "Name": "Levshunov",
        "Number": "55",
        "AorC": "          "
    },
    "14054": {
        "Name": "Bertuzzi",
        "Number": "59",
        "AorC": "          "
    },
    "14055": {
        "Name": "Vlasic",
        "Number": "72",
        "AorC": "          "
    },
    "14056": {
        "Name": "Reichel",
        "Number": "73",
        "AorC": "          "
    },
    "14057": {
        "Name": "Slaggert",
        "Number": "84",
        "AorC": "          "
    },
    "14058": {
        "Name": "Teravainen",
        "Number": "86",
        "AorC": "          "
    },
    "14059": {
        "Name": "Nazar",
        "Number": "91",
        "AorC": "          "
    },
    "14060": {
        "Name": "Mikheyev",
        "Number": "95",
        "AorC": "          "
    },
    "14061": {
        "Name": "Bedard",
        "Number": "98",
        "AorC": "          "
    },
    "14062": {
        "Name": "Middleton",
        "Number": "5",
        "AorC": "          "
    },
    "14063": {
        "Name": "Faber",
        "Number": "7",
        "AorC": "          "
    },
    "14064": {
        "Name": "Buium",
        "Number": "8",
        "AorC": "          "
    },
    "14065": {
        "Name": "Boldy",
        "Number": "12",
        "AorC": "          "
    },
    "14066": {
        "Name": "Trenin",
        "Number": "13",
        "AorC": "          "
    },
    "14067": {
        "Name": "Eriksson Ek",
        "Number": "14",
        "AorC": "          "
    },
    "14068": {
        "Name": "Foligno",
        "Number": "17",
        "AorC": "          "
    },
    "14069": {
        "Name": "Hinostroza",
        "Number": "18",
        "AorC": "          "
    },
    "14070": {
        "Name": "Yurov",
        "Number": "22",
        "AorC": "          "
    },
    "14071": {
        "Name": "Rossi",
        "Number": "23",
        "AorC": "          "
    },
    "14072": {
        "Name": "Bogosian",
        "Number": "24",
        "AorC": "          "
    },
    "14073": {
        "Name": "Brodin",
        "Number": "25",
        "AorC": "          "
    },
    "14074": {
        "Name": "Butler",
        "Number": "27",
        "AorC": "          "
    },
    "14075": {
        "Name": "Ohgren",
        "Number": "28",
        "AorC": "          "
    },
    "14076": {
        "Name": "Wallstedt",
        "Number": "30",
        "AorC": "          "
    },
    "14077": {
        "Name": "Gustavsson",
        "Number": "32",
        "AorC": "          "
    },
    "14078": {
        "Name": "Zuccarello",
        "Number": "36",
        "AorC": "          "
    },
    "14079": {
        "Name": "Hartman",
        "Number": "38",
        "AorC": "          "
    },
    "14080": {
        "Name": "Spurgeon",
        "Number": "46",
        "AorC": "C         "
    },
    "14081": {
        "Name": "Hunt",
        "Number": "48",
        "AorC": "          "
    },
    "14082": {
        "Name": "Jiricek",
        "Number": "55",
        "AorC": "          "
    },
    "14083": {
        "Name": "Milne",
        "Number": "60",
        "AorC": "          "
    },
    "14084": {
        "Name": "Sturm",
        "Number": "78",
        "AorC": "          "
    },
    "14085": {
        "Name": "Leskovar",
        "Number": "81",
        "AorC": "          "
    },
    "14086": {
        "Name": "Johansson",
        "Number": "90",
        "AorC": "          "
    },
    "14087": {
        "Name": "Tarasenko",
        "Number": "91",
        "AorC": "          "
    },
    "14088": {
        "Name": "Kaprizov",
        "Number": "97",
        "AorC": "          "
    },
    "14089": {
        "Name": "Maatta",
        "Number": "2",
        "AorC": "          "
    },
    "14090": {
        "Name": "Valimaki",
        "Number": "4",
        "AorC": "          "
    },
    "14091": {
        "Name": "Marino",
        "Number": "6",
        "AorC": "          "
    },
    "14092": {
        "Name": "Schmaltz",
        "Number": "8",
        "AorC": "          "
    },
    "14093": {
        "Name": "Keller",
        "Number": "9",
        "AorC": "C         "
    },
    "14094": {
        "Name": "Guenther",
        "Number": "11",
        "AorC": "          "
    },
    "14095": {
        "Name": "Iginla",
        "Number": "12",
        "AorC": "          "
    },
    "14096": {
        "Name": "Tanev",
        "Number": "13",
        "AorC": "          "
    },
    "14097": {
        "Name": "Kerfoot",
        "Number": "15",
        "AorC": "          "
    },
    "14098": {
        "Name": "But",
        "Number": "19",
        "AorC": "          "
    },
    "14099": {
        "Name": "McBain",
        "Number": "22",
        "AorC": "          "
    },
    "14100": {
        "Name": "Simashev",
        "Number": "26",
        "AorC": "          "
    },
    "14101": {
        "Name": "Hayton",
        "Number": "27",
        "AorC": "          "
    },
    "14102": {
        "Name": "Cole",
        "Number": "28",
        "AorC": "          "
    },
    "14103": {
        "Name": "Thornton",
        "Number": "34",
        "AorC": "          "
    },
    "14104": {
        "Name": "Agozzino",
        "Number": "36",
        "AorC": "          "
    },
    "14105": {
        "Name": "O'Brien",
        "Number": "38",
        "AorC": "          "
    },
    "14106": {
        "Name": "Vanecek",
        "Number": "41",
        "AorC": "          "
    },
    "14107": {
        "Name": "Durzi",
        "Number": "50",
        "AorC": "          "
    },
    "14108": {
        "Name": "Carcone",
        "Number": "53",
        "AorC": "          "
    },
    "14109": {
        "Name": "Goldsmith",
        "Number": "54",
        "AorC": "          "
    },
    "14110": {
        "Name": "Yamamoto",
        "Number": "56",
        "AorC": "          "
    },
    "14111": {
        "Name": "DeSimone",
        "Number": "57",
        "AorC": "          "
    },
    "14112": {
        "Name": "Crouse",
        "Number": "67",
        "AorC": "          "
    },
    "14113": {
        "Name": "Vejmelka",
        "Number": "70",
        "AorC": "          "
    },
    "14114": {
        "Name": "Peterka",
        "Number": "77",
        "AorC": "          "
    },
    "14115": {
        "Name": "Stenlund",
        "Number": "82",
        "AorC": "          "
    },
    "14116": {
        "Name": "Schmidt",
        "Number": "88",
        "AorC": "          "
    },
    "14117": {
        "Name": "Cooley",
        "Number": "92",
        "AorC": "          "
    },
    "14118": {
        "Name": "Sergachev",
        "Number": "98",
        "AorC": "          "
    },
    "14119": {
        "Name": "Dumoulin",
        "Number": "2",
        "AorC": "          "
    },
    "14120": {
        "Name": "Ceci",
        "Number": "5",
        "AorC": "          "
    },
    "14121": {
        "Name": "Edmundson",
        "Number": "6",
        "AorC": "          "
    },
    "14122": {
        "Name": "Burroughs",
        "Number": "7",
        "AorC": "          "
    },
    "14123": {
        "Name": "Doughty",
        "Number": "8",
        "AorC": "          "
    },
    "14124": {
        "Name": "Kempe",
        "Number": "9",
        "AorC": "          "
    },
    "14125": {
        "Name": "Perry",
        "Number": "10",
        "AorC": "          "
    },
    "14126": {
        "Name": "Kopitar",
        "Number": "11",
        "AorC": "C         "
    },
    "14127": {
        "Name": "Moore",
        "Number": "12",
        "AorC": "          "
    },
    "14128": {
        "Name": "Laferriere",
        "Number": "14",
        "AorC": "          "
    },
    "14129": {
        "Name": "Turcotte",
        "Number": "15",
        "AorC": "          "
    },
    "14130": {
        "Name": "Fiala",
        "Number": "22",
        "AorC": "          "
    },
    "14131": {
        "Name": "Danault",
        "Number": "24",
        "AorC": "          "
    },
    "14132": {
        "Name": "Copley",
        "Number": "29",
        "AorC": "          "
    },
    "14133": {
        "Name": "Forsberg",
        "Number": "31",
        "AorC": "          "
    },
    "14134": {
        "Name": "Kuemper",
        "Number": "35",
        "AorC": "          "
    },
    "14135": {
        "Name": "Foegele",
        "Number": "37",
        "AorC": "          "
    },
    "14136": {
        "Name": "Malott",
        "Number": "39",
        "AorC": "          "
    },
    "14137": {
        "Name": "Armia",
        "Number": "40",
        "AorC": "          "
    },
    "14138": {
        "Name": "Moverare",
        "Number": "43",
        "AorC": "          "
    },
    "14139": {
        "Name": "Anderson",
        "Number": "44",
        "AorC": "          "
    },
    "14140": {
        "Name": "Doty",
        "Number": "45",
        "AorC": "          "
    },
    "14141": {
        "Name": "Isogai",
        "Number": "46",
        "AorC": "          "
    },
    "14142": {
        "Name": "Byfield",
        "Number": "55",
        "AorC": "          "
    },
    "14143": {
        "Name": "Hughes",
        "Number": "62",
        "AorC": "          "
    },
    "14144": {
        "Name": "Helenius",
        "Number": "79",
        "AorC": "          "
    },
    "14145": {
        "Name": "Booth",
        "Number": "81",
        "AorC": "          "
    },
    "14146": {
        "Name": "Clarke",
        "Number": "92",
        "AorC": "          "
    },
    "14147": {
        "Name": "Kuzmenko",
        "Number": "96",
        "AorC": "          "
    },
    "14148": {
        "Name": "Woo",
        "Number": "4",
        "AorC": "          "
    },
    "14149": {
        "Name": "Boeser",
        "Number": "6",
        "AorC": "          "
    },
    "14150": {
        "Name": "Joseph",
        "Number": "7",
        "AorC": "          "
    },
    "14151": {
        "Name": "Garland",
        "Number": "8",
        "AorC": "          "
    },
    "14152": {
        "Name": "Bains",
        "Number": "13",
        "AorC": "          "
    },
    "14153": {
        "Name": "Hronek",
        "Number": "17",
        "AorC": "          "
    },
    "14154": {
        "Name": "O'Connor",
        "Number": "18",
        "AorC": "          "
    },
    "14155": {
        "Name": "Hoglander",
        "Number": "21",
        "AorC": "          "
    },
    "14156": {
        "Name": "Lekkerimaki",
        "Number": "23",
        "AorC": "          "
    },
    "14157": {
        "Name": "Pettersson",
        "Number": "25",
        "AorC": "          "
    },
    "14158": {
        "Name": "Forbort",
        "Number": "27",
        "AorC": "          "
    },
    "14159": {
        "Name": "Pettersson",
        "Number": "29",
        "AorC": "          "
    },
    "14160": {
        "Name": "Lankinen",
        "Number": "32",
        "AorC": "          "
    },
    "14161": {
        "Name": "Demko",
        "Number": "35",
        "AorC": "          "
    },
    "14162": {
        "Name": "Pettersson",
        "Number": "40",
        "AorC": "          "
    },
    "14163": {
        "Name": "Hughes",
        "Number": "43",
        "AorC": "          "
    },
    "14164": {
        "Name": "Sherwood",
        "Number": "44",
        "AorC": "          "
    },
    "14165": {
        "Name": "Blueger",
        "Number": "53",
        "AorC": "          "
    },
    "14166": {
        "Name": "Raty",
        "Number": "54",
        "AorC": "          "
    },
    "14167": {
        "Name": "Brisebois",
        "Number": "55",
        "AorC": "          "
    },
    "14168": {
        "Name": "Myers",
        "Number": "57",
        "AorC": "          "
    },
    "14169": {
        "Name": "Chytil",
        "Number": "72",
        "AorC": "          "
    },
    "14170": {
        "Name": "DeBrusk",
        "Number": "74",
        "AorC": "          "
    },
    "14171": {
        "Name": "Cootes",
        "Number": "80",
        "AorC": "          "
    },
    "14172": {
        "Name": "Kane",
        "Number": "91",
        "AorC": "          "
    },
    "14173": {
        "Name": "Karlsson",
        "Number": "94",
        "AorC": "          "
    },
    "14174": {
        "Name": "Luukkonen",
        "Number": "1",
        "AorC": "          "
    },
    "14175": {
        "Name": "Byram",
        "Number": "4",
        "AorC": "          "
    },
    "14176": {
        "Name": "Benson",
        "Number": "6",
        "AorC": "          "
    },
    "14177": {
        "Name": "Kesselring",
        "Number": "8",
        "AorC": "          "
    },
    "14178": {
        "Name": "Norris",
        "Number": "9",
        "AorC": "          "
    },
    "14179": {
        "Name": "Greenway",
        "Number": "12",
        "AorC": "          "
    },
    "14180": {
        "Name": "Danforth",
        "Number": "15",
        "AorC": "          "
    },
    "14181": {
        "Name": "Turcotte",
        "Number": "15",
        "AorC": "          "
    },
    "14182": {
        "Name": "Zucker",
        "Number": "17",
        "AorC": "          "
    },
    "14183": {
        "Name": "Krebs",
        "Number": "19",
        "AorC": "          "
    },
    "14184": {
        "Name": "Kulich",
        "Number": "20",
        "AorC": "          "
    },
    "14185": {
        "Name": "Timmins",
        "Number": "21",
        "AorC": "          "
    },
    "14186": {
        "Name": "Quinn",
        "Number": "22",
        "AorC": "          "
    },
    "14187": {
        "Name": "Samuelsson",
        "Number": "23",
        "AorC": "          "
    },
    "14188": {
        "Name": "Power",
        "Number": "25",
        "AorC": "          "
    },
    "14189": {
        "Name": "Dahlin",
        "Number": "26",
        "AorC": "C         "
    },
    "14190": {
        "Name": "Malenstyn",
        "Number": "29",
        "AorC": "          "
    },
    "14191": {
        "Name": "Johnson",
        "Number": "33",
        "AorC": "          "
    },
    "14192": {
        "Name": "Lyon",
        "Number": "34",
        "AorC": "          "
    },
    "14193": {
        "Name": "Georgiev",
        "Number": "40",
        "AorC": "          "
    },
    "14194": {
        "Name": "Kozak",
        "Number": "48",
        "AorC": "          "
    },
    "14195": {
        "Name": "Meyer",
        "Number": "49",
        "AorC": "          "
    },
    "14196": {
        "Name": "Geertsen",
        "Number": "55",
        "AorC": "          "
    },
    "14197": {
        "Name": "McLeod",
        "Number": "71",
        "AorC": "          "
    },
    "14198": {
        "Name": "Thompson",
        "Number": "72",
        "AorC": "          "
    },
    "14199": {
        "Name": "Bryson",
        "Number": "78",
        "AorC": "          "
    },
    "14200": {
        "Name": "Tuch",
        "Number": "89",
        "AorC": "          "
    },
    "14201": {
        "Name": "Doan",
        "Number": "91",
        "AorC": "          "
    },
    "14202": {
        "Name": "Matheson",
        "Number": "8",
        "AorC": "          "
    },
    "14203": {
        "Name": "Gallagher",
        "Number": "11",
        "AorC": "          "
    },
    "14204": {
        "Name": "Caufield",
        "Number": "13",
        "AorC": "          "
    },
    "14205": {
        "Name": "Suzuki",
        "Number": "14",
        "AorC": "C         "
    },
    "14206": {
        "Name": "Newhook",
        "Number": "15",
        "AorC": "          "
    },
    "14207": {
        "Name": "Anderson",
        "Number": "17",
        "AorC": "          "
    },
    "14208": {
        "Name": "Slafkovsky",
        "Number": "20",
        "AorC": "          "
    },
    "14209": {
        "Name": "Guhle",
        "Number": "21",
        "AorC": "          "
    },
    "14210": {
        "Name": "Montembeault",
        "Number": "35",
        "AorC": "          "
    },
    "14211": {
        "Name": "Del Gaizo",
        "Number": "37",
        "AorC": "          "
    },
    "14212": {
        "Name": "Clurman",
        "Number": "44",
        "AorC": "          "
    },
    "14213": {
        "Name": "Carrier",
        "Number": "45",
        "AorC": "          "
    },
    "14214": {
        "Name": "Struble",
        "Number": "47",
        "AorC": "          "
    },
    "14215": {
        "Name": "Hutson",
        "Number": "48",
        "AorC": "          "
    },
    "14216": {
        "Name": "Dobson",
        "Number": "53",
        "AorC": "          "
    },
    "14217": {
        "Name": "Farrell",
        "Number": "57",
        "AorC": "          "
    },
    "14218": {
        "Name": "Belzile",
        "Number": "60",
        "AorC": "          "
    },
    "14219": {
        "Name": "Reinbacher",
        "Number": "64",
        "AorC": "          "
    },
    "14220": {
        "Name": "Evans",
        "Number": "71",
        "AorC": "          "
    },
    "14221": {
        "Name": "Xhekaj",
        "Number": "72",
        "AorC": "          "
    },
    "14222": {
        "Name": "Dobes",
        "Number": "75",
        "AorC": "          "
    },
    "14223": {
        "Name": "Bolduc",
        "Number": "76",
        "AorC": "          "
    },
    "14224": {
        "Name": "Dach",
        "Number": "77",
        "AorC": "          "
    },
    "14225": {
        "Name": "Condotta",
        "Number": "82",
        "AorC": "          "
    },
    "14226": {
        "Name": "Trudeau",
        "Number": "84",
        "AorC": "          "
    },
    "14227": {
        "Name": "Veleno",
        "Number": "90",
        "AorC": "          "
    },
    "14228": {
        "Name": "Kapanen",
        "Number": "91",
        "AorC": "          "
    },
    "14229": {
        "Name": "Laine",
        "Number": "92",
        "AorC": "          "
    },
    "14230": {
        "Name": "Demidov",
        "Number": "93",
        "AorC": "          "
    },
    "14231": {
        "Name": "Rohrer",
        "Number": "96",
        "AorC": "          "
    },
    "14232": {
        "Name": "Benoit",
        "Number": "2",
        "AorC": "          "
    },
    "14233": {
        "Name": "Tanev",
        "Number": "8",
        "AorC": "          "
    },
    "14234": {
        "Name": "Domi",
        "Number": "11",
        "AorC": "          "
    },
    "14235": {
        "Name": "Lorentz",
        "Number": "18",
        "AorC": "          "
    },
    "14236": {
        "Name": "Jarnkrok",
        "Number": "19",
        "AorC": "          "
    },
    "14237": {
        "Name": "McCabe",
        "Number": "22",
        "AorC": "          "
    },
    "14238": {
        "Name": "Knies",
        "Number": "23",
        "AorC": "          "
    },
    "14239": {
        "Name": "Laughton",
        "Number": "24",
        "AorC": "          "
    },
    "14240": {
        "Name": "Carlo",
        "Number": "25",
        "AorC": "          "
    },
    "14241": {
        "Name": "Matthews",
        "Number": "34",
        "AorC": "C         "
    },
    "14242": {
        "Name": "Hildeby",
        "Number": "35",
        "AorC": "          "
    },
    "14243": {
        "Name": "Mermis",
        "Number": "36",
        "AorC": "          "
    },
    "14244": {
        "Name": "Danford",
        "Number": "38",
        "AorC": "          "
    },
    "14245": {
        "Name": "Stolarz",
        "Number": "41",
        "AorC": "          "
    },
    "14246": {
        "Name": "Rielly",
        "Number": "44",
        "AorC": "          "
    },
    "14247": {
        "Name": "Reimer",
        "Number": "47",
        "AorC": "          "
    },
    "14248": {
        "Name": "Myers",
        "Number": "51",
        "AorC": "          "
    },
    "14249": {
        "Name": "Cowan",
        "Number": "53",
        "AorC": "          "
    },
    "14250": {
        "Name": "Roy",
        "Number": "55",
        "AorC": "          "
    },
    "14251": {
        "Name": "Woll",
        "Number": "60",
        "AorC": "          "
    },
    "14252": {
        "Name": "Maccelli",
        "Number": "63",
        "AorC": "          "
    },
    "14253": {
        "Name": "McMann",
        "Number": "74",
        "AorC": "          "
    },
    "14254": {
        "Name": "Joshua",
        "Number": "81",
        "AorC": "          "
    },
    "14255": {
        "Name": "Rifai",
        "Number": "83",
        "AorC": "          "
    },
    "14256": {
        "Name": "Nylander",
        "Number": "88",
        "AorC": "          "
    },
    "14257": {
        "Name": "Robertson",
        "Number": "89",
        "AorC": "          "
    },
    "14258": {
        "Name": "Tavares",
        "Number": "91",
        "AorC": "          "
    },
    "14259": {
        "Name": "Ekman-Larsson",
        "Number": "95",
        "AorC": "          "
    },
    "14260": {
        "Name": "Holinka",
        "Number": "98",
        "AorC": "          "
    },
    "14261": {
        "Name": "Christiansen",
        "Number": "2",
        "AorC": "          "
    },
    "14262": {
        "Name": "Coyle",
        "Number": "3",
        "AorC": "          "
    },
    "14263": {
        "Name": "Sillinger",
        "Number": "4",
        "AorC": "          "
    },
    "14264": {
        "Name": "Mateychuk",
        "Number": "5",
        "AorC": "          "
    },
    "14265": {
        "Name": "Werenski",
        "Number": "8",
        "AorC": "          "
    },
    "14266": {
        "Name": "Provorov",
        "Number": "9",
        "AorC": "          "
    },
    "14267": {
        "Name": "Voronkov",
        "Number": "10",
        "AorC": "          "
    },
    "14268": {
        "Name": "Wood",
        "Number": "11",
        "AorC": "          "
    },
    "14269": {
        "Name": "Fabbro",
        "Number": "15",
        "AorC": "          "
    },
    "14270": {
        "Name": "Fantilli",
        "Number": "19",
        "AorC": "          "
    },
    "14271": {
        "Name": "Lundestrom",
        "Number": "21",
        "AorC": "          "
    },
    "14272": {
        "Name": "Dumais",
        "Number": "22",
        "AorC": "          "
    },
    "14273": {
        "Name": "Monahan",
        "Number": "23",
        "AorC": "          "
    },
    "14274": {
        "Name": "Olivier",
        "Number": "24",
        "AorC": "          "
    },
    "14275": {
        "Name": "Aston-Reese",
        "Number": "27",
        "AorC": "          "
    },
    "14276": {
        "Name": "Jenner",
        "Number": "38",
        "AorC": "C         "
    },
    "14277": {
        "Name": "Gudbranson",
        "Number": "44",
        "AorC": "          "
    },
    "14278": {
        "Name": "Marrelli",
        "Number": "54",
        "AorC": "          "
    },
    "14279": {
        "Name": "Chinakhov",
        "Number": "59",
        "AorC": "          "
    },
    "14280": {
        "Name": "Greaves",
        "Number": "73",
        "AorC": "          "
    },
    "14281": {
        "Name": "Severson",
        "Number": "78",
        "AorC": "          "
    },
    "14282": {
        "Name": "Marchenko",
        "Number": "86",
        "AorC": "          "
    },
    "14283": {
        "Name": "Merzlikins",
        "Number": "90",
        "AorC": "          "
    },
    "14284": {
        "Name": "Johnson",
        "Number": "91",
        "AorC": "          "
    },
    "14285": {
        "Name": "Schneider",
        "Number": "4",
        "AorC": "          "
    },
    "14286": {
        "Name": "Miller",
        "Number": "8",
        "AorC": "C         "
    },
    "14287": {
        "Name": "Panarin",
        "Number": "10",
        "AorC": "          "
    },
    "14288": {
        "Name": "Lafreniere",
        "Number": "13",
        "AorC": "          "
    },
    "14289": {
        "Name": "Raddysh",
        "Number": "14",
        "AorC": "          "
    },
    "14290": {
        "Name": "Trocheck",
        "Number": "16",
        "AorC": "          "
    },
    "14291": {
        "Name": "Borgen",
        "Number": "17",
        "AorC": "          "
    },
    "14292": {
        "Name": "Vaakanainen",
        "Number": "18",
        "AorC": "          "
    },
    "14293": {
        "Name": "Brodzinski",
        "Number": "22",
        "AorC": "          "
    },
    "14294": {
        "Name": "Fox",
        "Number": "23",
        "AorC": "          "
    },
    "14295": {
        "Name": "Soucy",
        "Number": "24",
        "AorC": "          "
    },
    "14296": {
        "Name": "Robertson",
        "Number": "29",
        "AorC": "          "
    },
    "14297": {
        "Name": "Shesterkin",
        "Number": "31",
        "AorC": "          "
    },
    "14298": {
        "Name": "Quick",
        "Number": "32",
        "AorC": "          "
    },
    "14299": {
        "Name": "Sustr",
        "Number": "36",
        "AorC": "          "
    },
    "14300": {
        "Name": "Sykora",
        "Number": "38",
        "AorC": "          "
    },
    "14301": {
        "Name": "Carrick",
        "Number": "39",
        "AorC": "          "
    },
    "14302": {
        "Name": "Laba",
        "Number": "42",
        "AorC": "          "
    },
    "14303": {
        "Name": "Sheary",
        "Number": "43",
        "AorC": "          "
    },
    "14304": {
        "Name": "Gavrikov",
        "Number": "44",
        "AorC": "          "
    },
    "14305": {
        "Name": "Chmelar",
        "Number": "49",
        "AorC": "          "
    },
    "14306": {
        "Name": "Cuylle",
        "Number": "50",
        "AorC": "          "
    },
    "14307": {
        "Name": "McCarthy",
        "Number": "53",
        "AorC": "          "
    },
    "14308": {
        "Name": "Berard",
        "Number": "65",
        "AorC": "          "
    },
    "14309": {
        "Name": "Parssinen",
        "Number": "71",
        "AorC": "          "
    },
    "14310": {
        "Name": "Rempe",
        "Number": "73",
        "AorC": "          "
    },
    "14311": {
        "Name": "Dorrington",
        "Number": "83",
        "AorC": "          "
    },
    "14312": {
        "Name": "Edstrom",
        "Number": "84",
        "AorC": "          "
    },
    "14313": {
        "Name": "Zibanejad",
        "Number": "93",
        "AorC": "          "
    },
    "14314": {
        "Name": "Vaisanen",
        "Number": "97",
        "AorC": "          "
    },
    "14315": {
        "Name": "Iorio",
        "Number": "2",
        "AorC": "          "
    },
    "14316": {
        "Name": "Roy",
        "Number": "3",
        "AorC": "          "
    },
    "14317": {
        "Name": "Chychrun",
        "Number": "6",
        "AorC": "          "
    },
    "14318": {
        "Name": "Ovechkin",
        "Number": "8",
        "AorC": "C         "
    },
    "14319": {
        "Name": "Leonard",
        "Number": "9",
        "AorC": "          "
    },
    "14320": {
        "Name": "Milano",
        "Number": "15",
        "AorC": "          "
    },
    "14321": {
        "Name": "Strome",
        "Number": "17",
        "AorC": "          "
    },
    "14322": {
        "Name": "Protas",
        "Number": "21",
        "AorC": "          "
    },
    "14323": {
        "Name": "Duhaime",
        "Number": "22",
        "AorC": "          "
    },
    "14324": {
        "Name": "McMichael",
        "Number": "24",
        "AorC": "          "
    },
    "14325": {
        "Name": "Dowd",
        "Number": "26",
        "AorC": "          "
    },
    "14326": {
        "Name": "Lapierre",
        "Number": "29",
        "AorC": "          "
    },
    "14327": {
        "Name": "Sourdif",
        "Number": "34",
        "AorC": "          "
    },
    "14328": {
        "Name": "Sandin",
        "Number": "38",
        "AorC": "          "
    },
    "14329": {
        "Name": "Fehervary",
        "Number": "42",
        "AorC": "          "
    },
    "14330": {
        "Name": "Wilson",
        "Number": "43",
        "AorC": "          "
    },
    "14331": {
        "Name": "Chisholm",
        "Number": "47",
        "AorC": "          "
    },
    "14332": {
        "Name": "Thompson",
        "Number": "48",
        "AorC": "          "
    },
    "14333": {
        "Name": "Ness",
        "Number": "51",
        "AorC": "          "
    },
    "14334": {
        "Name": "McIlrath",
        "Number": "52",
        "AorC": "          "
    },
    "14335": {
        "Name": "van Riemsdyk",
        "Number": "57",
        "AorC": "          "
    },
    "14336": {
        "Name": "Miroshnichenko",
        "Number": "63",
        "AorC": "          "
    },
    "14337": {
        "Name": "Funk",
        "Number": "71",
        "AorC": "          "
    },
    "14338": {
        "Name": "Beauvillier",
        "Number": "72",
        "AorC": "          "
    },
    "14339": {
        "Name": "Carlson",
        "Number": "74",
        "AorC": "          "
    },
    "14340": {
        "Name": "Lindgren",
        "Number": "79",
        "AorC": "          "
    },
    "14341": {
        "Name": "Dubois",
        "Number": "80",
        "AorC": "          "
    },
    "14342": {
        "Name": "Behrens",
        "Number": "2",
        "AorC": "          "
    },
    "14343": {
        "Name": "MacDonald",
        "Number": "4",
        "AorC": "          "
    },
    "14344": {
        "Name": "Toews",
        "Number": "7",
        "AorC": "          "
    },
    "14345": {
        "Name": "Makar",
        "Number": "8",
        "AorC": "          "
    },
    "14346": {
        "Name": "Nelson",
        "Number": "11",
        "AorC": "          "
    },
    "14347": {
        "Name": "Megna",
        "Number": "12",
        "AorC": "          "
    },
    "14348": {
        "Name": "Nichushkin",
        "Number": "13",
        "AorC": "          "
    },
    "14349": {
        "Name": "Kelly",
        "Number": "17",
        "AorC": "          "
    },
    "14350": {
        "Name": "Drury",
        "Number": "18",
        "AorC": "          "
    },
    "14351": {
        "Name": "Colton",
        "Number": "20",
        "AorC": "          "
    },
    "14352": {
        "Name": "O'Connor",
        "Number": "25",
        "AorC": "          "
    },
    "14353": {
        "Name": "Solovyov",
        "Number": "28",
        "AorC": "          "
    },
    "14354": {
        "Name": "MacKinnon",
        "Number": "29",
        "AorC": "          "
    },
    "14355": {
        "Name": "Blackwood",
        "Number": "39",
        "AorC": "          "
    },
    "14356": {
        "Name": "Wedgewood",
        "Number": "41",
        "AorC": "          "
    },
    "14357": {
        "Name": "Manson",
        "Number": "42",
        "AorC": "          "
    },
    "14358": {
        "Name": "Girard",
        "Number": "49",
        "AorC": "          "
    },
    "14359": {
        "Name": "Miner",
        "Number": "50",
        "AorC": "          "
    },
    "14360": {
        "Name": "Senden",
        "Number": "51",
        "AorC": "          "
    },
    "14361": {
        "Name": "Brindley",
        "Number": "54",
        "AorC": "          "
    },
    "14362": {
        "Name": "Lehkonen",
        "Number": "62",
        "AorC": "          "
    },
    "14363": {
        "Name": "Malinski",
        "Number": "70",
        "AorC": "          "
    },
    "14364": {
        "Name": "Burns",
        "Number": "84",
        "AorC": "          "
    },
    "14365": {
        "Name": "Prishchepov",
        "Number": "85",
        "AorC": "          "
    },
    "14366": {
        "Name": "Necas",
        "Number": "88",
        "AorC": "          "
    },
    "14367": {
        "Name": "Landeskog",
        "Number": "92",
        "AorC": "C         "
    },
    "14368": {
        "Name": "Bardakov",
        "Number": "93",
        "AorC": "          "
    },
    "14369": {
        "Name": "Kiviranta",
        "Number": "94",
        "AorC": "          "
    },
    "14370": {
        "Name": "Olofsson",
        "Number": "95",
        "AorC": "          "
    },
    "14371": {
        "Name": "Forsberg",
        "Number": "9",
        "AorC": "          "
    },
    "14372": {
        "Name": "Jost",
        "Number": "17",
        "AorC": "          "
    },
    "14373": {
        "Name": "Barron",
        "Number": "20",
        "AorC": "          "
    },
    "14374": {
        "Name": "Stastney",
        "Number": "24",
        "AorC": "          "
    },
    "14375": {
        "Name": "Kemell",
        "Number": "25",
        "AorC": "          "
    },
    "14376": {
        "Name": "Annunen",
        "Number": "29",
        "AorC": "          "
    },
    "14377": {
        "Name": "Smith",
        "Number": "36",
        "AorC": "          "
    },
    "14378": {
        "Name": "Blankenburg",
        "Number": "37",
        "AorC": "          "
    },
    "14379": {
        "Name": "Svechkov",
        "Number": "40",
        "AorC": "          "
    },
    "14380": {
        "Name": "Hague",
        "Number": "41",
        "AorC": "          "
    },
    "14381": {
        "Name": "Martin",
        "Number": "44",
        "AorC": "          "
    },
    "14382": {
        "Name": "McCarron",
        "Number": "47",
        "AorC": "          "
    },
    "14383": {
        "Name": "Perbix",
        "Number": "48",
        "AorC": "          "
    },
    "14384": {
        "Name": "Haula",
        "Number": "56",
        "AorC": "          "
    },
    "14385": {
        "Name": "Bunting",
        "Number": "58",
        "AorC": "          "
    },
    "14386": {
        "Name": "Josi",
        "Number": "59",
        "AorC": "C         "
    },
    "14387": {
        "Name": "Wood",
        "Number": "71",
        "AorC": "          "
    },
    "14388": {
        "Name": "Saros",
        "Number": "74",
        "AorC": "          "
    },
    "14389": {
        "Name": "Skjei",
        "Number": "76",
        "AorC": "          "
    },
    "14390": {
        "Name": "Evangelista",
        "Number": "77",
        "AorC": "          "
    },
    "14391": {
        "Name": "Marchessault",
        "Number": "81",
        "AorC": "          "
    },
    "14392": {
        "Name": "Wilsby",
        "Number": "83",
        "AorC": "          "
    },
    "14393": {
        "Name": "Wiesblatt",
        "Number": "89",
        "AorC": "          "
    },
    "14394": {
        "Name": "O'Reilly",
        "Number": "90",
        "AorC": "          "
    },
    "14395": {
        "Name": "Stamkos",
        "Number": "91",
        "AorC": "          "
    },
    "14396": {
        "Name": "Comrie",
        "Number": "1",
        "AorC": "          "
    },
    "14397": {
        "Name": "DeMelo",
        "Number": "2",
        "AorC": "          "
    },
    "14398": {
        "Name": "Pionk",
        "Number": "4",
        "AorC": "          "
    },
    "14399": {
        "Name": "Schenn",
        "Number": "5",
        "AorC": "          "
    },
    "14400": {
        "Name": "Miller",
        "Number": "6",
        "AorC": "          "
    },
    "14401": {
        "Name": "Namestnikov",
        "Number": "7",
        "AorC": "          "
    },
    "14402": {
        "Name": "Iafallo",
        "Number": "9",
        "AorC": "          "
    },
    "14403": {
        "Name": "Vilardi",
        "Number": "13",
        "AorC": "          "
    },
    "14404": {
        "Name": "Nyquist",
        "Number": "14",
        "AorC": "          "
    },
    "14405": {
        "Name": "Lowry",
        "Number": "17",
        "AorC": "C         "
    },
    "14406": {
        "Name": "Toews",
        "Number": "19",
        "AorC": "          "
    },
    "14407": {
        "Name": "Fleury",
        "Number": "24",
        "AorC": "          "
    },
    "14408": {
        "Name": "Ford",
        "Number": "25",
        "AorC": "          "
    },
    "14409": {
        "Name": "Poulter",
        "Number": "30",
        "AorC": "          "
    },
    "14410": {
        "Name": "Barron",
        "Number": "36",
        "AorC": "          "
    },
    "14411": {
        "Name": "Hellebuyck",
        "Number": "37",
        "AorC": "          "
    },
    "14412": {
        "Name": "Gustafsson",
        "Number": "41",
        "AorC": "          "
    },
    "14413": {
        "Name": "Morrissey",
        "Number": "44",
        "AorC": "          "
    },
    "14414": {
        "Name": "Koepke",
        "Number": "45",
        "AorC": "          "
    },
    "14415": {
        "Name": "Zhilkin",
        "Number": "53",
        "AorC": "          "
    },
    "14416": {
        "Name": "Samberg",
        "Number": "54",
        "AorC": "          "
    },
    "14417": {
        "Name": "Scheifele",
        "Number": "55",
        "AorC": "          "
    },
    "14418": {
        "Name": "Wagner",
        "Number": "58",
        "AorC": "          "
    },
    "14419": {
        "Name": "Sautner",
        "Number": "61",
        "AorC": "          "
    },
    "14420": {
        "Name": "Niederreiter",
        "Number": "62",
        "AorC": "          "
    },
    "14421": {
        "Name": "Stanley",
        "Number": "64",
        "AorC": "          "
    },
    "14422": {
        "Name": "Julien",
        "Number": "67",
        "AorC": "          "
    },
    "14423": {
        "Name": "Pearson",
        "Number": "70",
        "AorC": "          "
    },
    "14424": {
        "Name": "Walton",
        "Number": "76",
        "AorC": "          "
    },
    "14425": {
        "Name": "Connor",
        "Number": "81",
        "AorC": "          "
    },
    "14426": {
        "Name": "Anhorn",
        "Number": "83",
        "AorC": "          "
    },
    "14427": {
        "Name": "Barteaux",
        "Number": "86",
        "AorC": "          "
    },
    "14428": {
        "Name": "Di Giuseppe",
        "Number": "89",
        "AorC": "          "
    },
    "14429": {
        "Name": "Chibrikov",
        "Number": "90",
        "AorC": "          "
    },
    "14430": {
        "Name": "Perfetti",
        "Number": "91",
        "AorC": "          "
    },
    "14431": {
        "Name": "Lambert",
        "Number": "93",
        "AorC": "          "
    },
    "14432": {
        "Name": "Cooley",
        "Number": "1",
        "AorC": "          "
    },
    "14433": {
        "Name": "Andersson",
        "Number": "4",
        "AorC": "          "
    },
    "14434": {
        "Name": "Bahl",
        "Number": "7",
        "AorC": "          "
    },
    "14435": {
        "Name": "Huberdeau",
        "Number": "10",
        "AorC": "          "
    },
    "14436": {
        "Name": "Backlund",
        "Number": "11",
        "AorC": "C         "
    },
    "14437": {
        "Name": "Frost",
        "Number": "16",
        "AorC": "          "
    },
    "14438": {
        "Name": "Sharangovich",
        "Number": "17",
        "AorC": "          "
    },
    "14439": {
        "Name": "Coleman",
        "Number": "20",
        "AorC": "          "
    },
    "14440": {
        "Name": "Kirkland",
        "Number": "23",
        "AorC": "          "
    },
    "14441": {
        "Name": "Bean",
        "Number": "24",
        "AorC": "          "
    },
    "14442": {
        "Name": "Coronato",
        "Number": "27",
        "AorC": "          "
    },
    "14443": {
        "Name": "Wolf",
        "Number": "32",
        "AorC": "          "
    },
    "14444": {
        "Name": "Klapka",
        "Number": "43",
        "AorC": "          "
    },
    "14445": {
        "Name": "Hanley",
        "Number": "44",
        "AorC": "          "
    },
    "14446": {
        "Name": "Zary",
        "Number": "47",
        "AorC": "          "
    },
    "14447": {
        "Name": "Gridin",
        "Number": "51",
        "AorC": "          "
    },
    "14448": {
        "Name": "Weegar",
        "Number": "52",
        "AorC": "          "
    },
    "14449": {
        "Name": "Miromanov",
        "Number": "62",
        "AorC": "          "
    },
    "14450": {
        "Name": "Lomberg",
        "Number": "70",
        "AorC": "          "
    },
    "14451": {
        "Name": "Pospisil",
        "Number": "76",
        "AorC": "          "
    },
    "14452": {
        "Name": "Farabee",
        "Number": "86",
        "AorC": "          "
    },
    "14453": {
        "Name": "Parekh",
        "Number": "89",
        "AorC": "          "
    },
    "14454": {
        "Name": "Kadri",
        "Number": "91",
        "AorC": "          "
    },
    "14455": {
        "Name": "Pachal",
        "Number": "94",
        "AorC": "          "
    },
    "14456": {
        "Name": "Smith",
        "Number": "2",
        "AorC": "          "
    },
    "14457": {
        "Name": "Klingberg",
        "Number": "3",
        "AorC": "          "
    },
    "14458": {
        "Name": "Leddy",
        "Number": "4",
        "AorC": "          "
    },
    "14459": {
        "Name": "Desharnais",
        "Number": "5",
        "AorC": "          "
    },
    "14460": {
        "Name": "Dickinson",
        "Number": "6",
        "AorC": "          "
    },
    "14461": {
        "Name": "Orlov",
        "Number": "9",
        "AorC": "          "
    },
    "14462": {
        "Name": "Dellandrea",
        "Number": "10",
        "AorC": "          "
    },
    "14463": {
        "Name": "Afanasyev",
        "Number": "11",
        "AorC": "          "
    },
    "14464": {
        "Name": "Wennberg",
        "Number": "21",
        "AorC": "          "
    },
    "14465": {
        "Name": "Goodrow",
        "Number": "23",
        "AorC": "          "
    },
    "14466": {
        "Name": "Thompson",
        "Number": "26",
        "AorC": "          "
    },
    "14467": {
        "Name": "Askarov",
        "Number": "30",
        "AorC": "          "
    },
    "14468": {
        "Name": "Carlsson",
        "Number": "32",
        "AorC": "          "
    },
    "14469": {
        "Name": "Nedeljkovic",
        "Number": "33",
        "AorC": "          "
    },
    "14470": {
        "Name": "Liljegren",
        "Number": "37",
        "AorC": "          "
    },
    "14471": {
        "Name": "Ferraro",
        "Number": "38",
        "AorC": "          "
    },
    "14472": {
        "Name": "Cagnoni",
        "Number": "42",
        "AorC": "          "
    },
    "14473": {
        "Name": "Graf",
        "Number": "51",
        "AorC": "          "
    },
    "14474": {
        "Name": "Skinner",
        "Number": "53",
        "AorC": "          "
    },
    "14475": {
        "Name": "Cardwell",
        "Number": "56",
        "AorC": "          "
    },
    "14476": {
        "Name": "Ostapchuk",
        "Number": "63",
        "AorC": "          "
    },
    "14477": {
        "Name": "Celebrini",
        "Number": "71",
        "AorC": "          "
    },
    "14478": {
        "Name": "Eklund",
        "Number": "72",
        "AorC": "          "
    },
    "14479": {
        "Name": "Toffoli",
        "Number": "73",
        "AorC": "A         "
    },
    "14480": {
        "Name": "Reaves",
        "Number": "75",
        "AorC": "          "
    },
    "14481": {
        "Name": "Misa",
        "Number": "77",
        "AorC": "          "
    },
    "14482": {
        "Name": "Gaudette",
        "Number": "81",
        "AorC": "          "
    },
    "14483": {
        "Name": "Villeneuve-Houle",
        "Number": "83",
        "AorC": "          "
    },
    "14484": {
        "Name": "Mukhamadullin",
        "Number": "85",
        "AorC": "          "
    },
    "14485": {
        "Name": "Kurashev",
        "Number": "96",
        "AorC": "          "
    },
    "14486": {
        "Name": "Chiarot",
        "Number": "8",
        "AorC": "          "
    },
    "14487": {
        "Name": "Copp",
        "Number": "18",
        "AorC": "          "
    },
    "14488": {
        "Name": "Johansson",
        "Number": "20",
        "AorC": "          "
    },
    "14489": {
        "Name": "van Riemsdyk",
        "Number": "21",
        "AorC": "          "
    },
    "14490": {
        "Name": "Appleton",
        "Number": "22",
        "AorC": "          "
    },
    "14491": {
        "Name": "Buium",
        "Number": "22",
        "AorC": "          "
    },
    "14492": {
        "Name": "Hamonic",
        "Number": "23",
        "AorC": "          "
    },
    "14493": {
        "Name": "Raymond",
        "Number": "23",
        "AorC": "          "
    },
    "14494": {
        "Name": "Bernard-Docker",
        "Number": "25",
        "AorC": "          "
    },
    "14495": {
        "Name": "Rasmussen",
        "Number": "27",
        "AorC": "          "
    },
    "14496": {
        "Name": "Brandsegg-Nygard",
        "Number": "28",
        "AorC": "          "
    },
    "14497": {
        "Name": "Danielson",
        "Number": "29",
        "AorC": "          "
    },
    "14498": {
        "Name": "Gibson",
        "Number": "36",
        "AorC": "          "
    },
    "14499": {
        "Name": "Compher",
        "Number": "37",
        "AorC": "          "
    },
    "14500": {
        "Name": "Talbot",
        "Number": "39",
        "AorC": "          "
    },
    "14501": {
        "Name": "Sandin-Pellikka",
        "Number": "44",
        "AorC": "          "
    },
    "14502": {
        "Name": "Berggren",
        "Number": "48",
        "AorC": "          "
    },
    "14503": {
        "Name": "Seider",
        "Number": "53",
        "AorC": "          "
    },
    "14504": {
        "Name": "Finnie",
        "Number": "58",
        "AorC": "          "
    },
    "14505": {
        "Name": "Larkin",
        "Number": "71",
        "AorC": "C         "
    },
    "14506": {
        "Name": "Edvinsson",
        "Number": "77",
        "AorC": "          "
    },
    "14507": {
        "Name": "Soderblom",
        "Number": "85",
        "AorC": "          "
    },
    "14508": {
        "Name": "Kane",
        "Number": "88",
        "AorC": "          "
    },
    "14509": {
        "Name": "Kasper",
        "Number": "92",
        "AorC": "          "
    },
    "14510": {
        "Name": "DeBrincat",
        "Number": "93",
        "AorC": "          "
    },
    "14511": {
        "Name": "Merilainen",
        "Number": "1",
        "AorC": "          "
    },
    "14512": {
        "Name": "Zub",
        "Number": "2",
        "AorC": "          "
    },
    "14513": {
        "Name": "Jensen",
        "Number": "3",
        "AorC": "          "
    },
    "14514": {
        "Name": "Tkachuk",
        "Number": "7",
        "AorC": "C         "
    },
    "14515": {
        "Name": "Spence",
        "Number": "10",
        "AorC": "          "
    },
    "14516": {
        "Name": "Pinto",
        "Number": "12",
        "AorC": "          "
    },
    "14517": {
        "Name": "Stutzle",
        "Number": "18",
        "AorC": "          "
    },
    "14518": {
        "Name": "Batherson",
        "Number": "19",
        "AorC": "          "
    },
    "14519": {
        "Name": "Ellinas",
        "Number": "19",
        "AorC": "          "
    },
    "14520": {
        "Name": "Zetterlund",
        "Number": "20",
        "AorC": "          "
    },
    "14521": {
        "Name": "Cousins",
        "Number": "21",
        "AorC": "          "
    },
    "14522": {
        "Name": "Amadio",
        "Number": "22",
        "AorC": "          "
    },
    "14523": {
        "Name": "MacDermid",
        "Number": "23",
        "AorC": "          "
    },
    "14524": {
        "Name": "Cozens",
        "Number": "24",
        "AorC": "          "
    },
    "14525": {
        "Name": "Giroux",
        "Number": "28",
        "AorC": "          "
    },
    "14526": {
        "Name": "Matinpalo",
        "Number": "33",
        "AorC": "          "
    },
    "14527": {
        "Name": "Ullmark",
        "Number": "35",
        "AorC": "          "
    },
    "14528": {
        "Name": "Sebrango",
        "Number": "37",
        "AorC": "          "
    },
    "14529": {
        "Name": "Kleven",
        "Number": "43",
        "AorC": "          "
    },
    "14530": {
        "Name": "Perron",
        "Number": "57",
        "AorC": "          "
    },
    "14531": {
        "Name": "Yakemchuk",
        "Number": "58",
        "AorC": "          "
    },
    "14532": {
        "Name": "Greig",
        "Number": "71",
        "AorC": "          "
    },
    "14533": {
        "Name": "Chabot",
        "Number": "72",
        "AorC": "          "
    },
    "14534": {
        "Name": "Sanderson",
        "Number": "85",
        "AorC": "          "
    },
    "14535": {
        "Name": "Eller",
        "Number": "89",
        "AorC": "          "
    },
    "14536": {
        "Name": "Dillon",
        "Number": "5",
        "AorC": "          "
    },
    "14537": {
        "Name": "Hamilton",
        "Number": "7",
        "AorC": "          "
    },
    "14538": {
        "Name": "Kovacevic",
        "Number": "8",
        "AorC": "          "
    },
    "14539": {
        "Name": "Rooney",
        "Number": "10",
        "AorC": "          "
    },
    "14540": {
        "Name": "Noesen",
        "Number": "11",
        "AorC": "          "
    },
    "14541": {
        "Name": "Glass",
        "Number": "12",
        "AorC": "          "
    },
    "14542": {
        "Name": "Hischier",
        "Number": "13",
        "AorC": "C         "
    },
    "14543": {
        "Name": "Glendening",
        "Number": "14",
        "AorC": "          "
    },
    "14544": {
        "Name": "Brown",
        "Number": "16",
        "AorC": "          "
    },
    "14545": {
        "Name": "Nemec",
        "Number": "17",
        "AorC": "          "
    },
    "14546": {
        "Name": "Palat",
        "Number": "18",
        "AorC": "          "
    },
    "14547": {
        "Name": "Lachance",
        "Number": "20",
        "AorC": "          "
    },
    "14548": {
        "Name": "McLaughlin",
        "Number": "21",
        "AorC": "          "
    },
    "14549": {
        "Name": "Pesce",
        "Number": "22",
        "AorC": "          "
    },
    "14550": {
        "Name": "Casey",
        "Number": "24",
        "AorC": "          "
    },
    "14551": {
        "Name": "Markstrom",
        "Number": "25",
        "AorC": "          "
    },
    "14552": {
        "Name": "Meier",
        "Number": "28",
        "AorC": "          "
    },
    "14553": {
        "Name": "Hameenaho",
        "Number": "29",
        "AorC": "          "
    },
    "14554": {
        "Name": "Dadonov",
        "Number": "33",
        "AorC": "          "
    },
    "14555": {
        "Name": "Allen",
        "Number": "34",
        "AorC": "          "
    },
    "14556": {
        "Name": "Hughes",
        "Number": "43",
        "AorC": "          "
    },
    "14557": {
        "Name": "Cholowski",
        "Number": "44",
        "AorC": "          "
    },
    "14558": {
        "Name": "Cotter",
        "Number": "47",
        "AorC": "          "
    },
    "14559": {
        "Name": "Bratt",
        "Number": "63",
        "AorC": "          "
    },
    "14560": {
        "Name": "Siegenthaler",
        "Number": "71",
        "AorC": "          "
    },
    "14561": {
        "Name": "Gritsyuk",
        "Number": "81",
        "AorC": "          "
    },
    "14562": {
        "Name": "Lammikko",
        "Number": "83",
        "AorC": "          "
    },
    "14563": {
        "Name": "Hughes",
        "Number": "86",
        "AorC": "          "
    },
    "14564": {
        "Name": "Mercer",
        "Number": "91",
        "AorC": "          "
    },
    "14565": {
        "Name": "Zamula",
        "Number": "5",
        "AorC": "          "
    },
    "14566": {
        "Name": "Sanheim",
        "Number": "6",
        "AorC": "          "
    },
    "14567": {
        "Name": "York",
        "Number": "8",
        "AorC": "          "
    },
    "14568": {
        "Name": "Drysdale",
        "Number": "9",
        "AorC": "          "
    },
    "14569": {
        "Name": "Brink",
        "Number": "10",
        "AorC": "          "
    },
    "14570": {
        "Name": "Konecny",
        "Number": "11",
        "AorC": "          "
    },
    "14571": {
        "Name": "Ginning",
        "Number": "13",
        "AorC": "          "
    },
    "14572": {
        "Name": "Couturier",
        "Number": "14",
        "AorC": "C         "
    },
    "14573": {
        "Name": "Luchanko",
        "Number": "17",
        "AorC": "          "
    },
    "14574": {
        "Name": "Abols",
        "Number": "18",
        "AorC": "          "
    },
    "14575": {
        "Name": "Hathaway",
        "Number": "19",
        "AorC": "          "
    },
    "14576": {
        "Name": "Dvorak",
        "Number": "22",
        "AorC": "          "
    },
    "14577": {
        "Name": "Seeler",
        "Number": "24",
        "AorC": "          "
    },
    "14578": {
        "Name": "Cates",
        "Number": "27",
        "AorC": "          "
    },
    "14579": {
        "Name": "Grebenkin",
        "Number": "29",
        "AorC": "          "
    },
    "14580": {
        "Name": "Ersson",
        "Number": "33",
        "AorC": "          "
    },
    "14581": {
        "Name": "Michkov",
        "Number": "39",
        "AorC": "          "
    },
    "14582": {
        "Name": "Deslauriers",
        "Number": "44",
        "AorC": "          "
    },
    "14583": {
        "Name": "Zegras",
        "Number": "46",
        "AorC": "          "
    },
    "14584": {
        "Name": "Juulsen",
        "Number": "47",
        "AorC": "          "
    },
    "14585": {
        "Name": "Ristolainen",
        "Number": "55",
        "AorC": "          "
    },
    "14586": {
        "Name": "Bonk",
        "Number": "59",
        "AorC": "          "
    },
    "14587": {
        "Name": "Foerster",
        "Number": "71",
        "AorC": "          "
    },
    "14588": {
        "Name": "Tippett",
        "Number": "74",
        "AorC": "          "
    },
    "14589": {
        "Name": "Samson",
        "Number": "75",
        "AorC": "          "
    },
    "14590": {
        "Name": "Vladar",
        "Number": "80",
        "AorC": "          "
    },
    "14591": {
        "Name": "DeSmith",
        "Number": "1",
        "AorC": "          "
    },
    "14592": {
        "Name": "Heiskanen",
        "Number": "4",
        "AorC": "          "
    },
    "14593": {
        "Name": "Lundkvist",
        "Number": "5",
        "AorC": "          "
    },
    "14594": {
        "Name": "Bichsel",
        "Number": "6",
        "AorC": "          "
    },
    "14595": {
        "Name": "Back",
        "Number": "10",
        "AorC": "          "
    },
    "14596": {
        "Name": "Bastian",
        "Number": "11",
        "AorC": "          "
    },
    "14597": {
        "Name": "Faksa",
        "Number": "12",
        "AorC": "          "
    },
    "14598": {
        "Name": "Benn",
        "Number": "14",
        "AorC": "C         "
    },
    "14599": {
        "Name": "Blackwell",
        "Number": "15",
        "AorC": "          "
    },
    "14600": {
        "Name": "Steel",
        "Number": "18",
        "AorC": "          "
    },
    "14601": {
        "Name": "Robertson",
        "Number": "21",
        "AorC": "          "
    },
    "14602": {
        "Name": "Bourque",
        "Number": "22",
        "AorC": "          "
    },
    "14603": {
        "Name": "Lindell",
        "Number": "23",
        "AorC": "          "
    },
    "14604": {
        "Name": "Hintz",
        "Number": "24",
        "AorC": "          "
    },
    "14605": {
        "Name": "Petrovic",
        "Number": "28",
        "AorC": "          "
    },
    "14606": {
        "Name": "Oettinger",
        "Number": "29",
        "AorC": "          "
    },
    "14607": {
        "Name": "Krys",
        "Number": "36",
        "AorC": "          "
    },
    "14608": {
        "Name": "McDonald",
        "Number": "40",
        "AorC": "          "
    },
    "14609": {
        "Name": "Lyubushkin",
        "Number": "46",
        "AorC": "          "
    },
    "14610": {
        "Name": "Wheatcroft",
        "Number": "48",
        "AorC": "          "
    },
    "14611": {
        "Name": "Johnston",
        "Number": "53",
        "AorC": "          "
    },
    "14612": {
        "Name": "Harley",
        "Number": "55",
        "AorC": "          "
    },
    "14613": {
        "Name": "Erne",
        "Number": "76",
        "AorC": "          "
    },
    "14614": {
        "Name": "Seguin",
        "Number": "91",
        "AorC": "          "
    },
    "14615": {
        "Name": "Duchene",
        "Number": "95",
        "AorC": "          "
    },
    "14616": {
        "Name": "Rantanen",
        "Number": "96",
        "AorC": "          "
    },
    "14617": {
        "Name": "Broberg",
        "Number": "6",
        "AorC": "          "
    },
    "14618": {
        "Name": "Texier",
        "Number": "9",
        "AorC": "          "
    },
    "14619": {
        "Name": "Schenn",
        "Number": "10",
        "AorC": "C         "
    },
    "14620": {
        "Name": "Lucic",
        "Number": "12",
        "AorC": "          "
    },
    "14621": {
        "Name": "Toropchenko",
        "Number": "13",
        "AorC": "          "
    },
    "14622": {
        "Name": "Fowler",
        "Number": "17",
        "AorC": "          "
    },
    "14623": {
        "Name": "Thomas",
        "Number": "18",
        "AorC": "          "
    },
    "14624": {
        "Name": "Snuggerud",
        "Number": "21",
        "AorC": "          "
    },
    "14625": {
        "Name": "Suter",
        "Number": "22",
        "AorC": "          "
    },
    "14626": {
        "Name": "Mailloux",
        "Number": "23",
        "AorC": "          "
    },
    "14627": {
        "Name": "Kyrou",
        "Number": "25",
        "AorC": "          "
    },
    "14628": {
        "Name": "Walker",
        "Number": "26",
        "AorC": "          "
    },
    "14629": {
        "Name": "Hofer",
        "Number": "30",
        "AorC": "          "
    },
    "14630": {
        "Name": "Koprowski",
        "Number": "45",
        "AorC": "          "
    },
    "14631": {
        "Name": "Krug",
        "Number": "47",
        "AorC": "          "
    },
    "14632": {
        "Name": "Binnington",
        "Number": "50",
        "AorC": "          "
    },
    "14633": {
        "Name": "Kessel",
        "Number": "51",
        "AorC": "          "
    },
    "14634": {
        "Name": "Dean",
        "Number": "52",
        "AorC": "          "
    },
    "14635": {
        "Name": "Parayko",
        "Number": "55",
        "AorC": "          "
    },
    "14636": {
        "Name": "Neighbours",
        "Number": "63",
        "AorC": "          "
    },
    "14637": {
        "Name": "Sundqvist",
        "Number": "70",
        "AorC": "          "
    },
    "14638": {
        "Name": "Joseph",
        "Number": "71",
        "AorC": "          "
    },
    "14639": {
        "Name": "Faulk",
        "Number": "72",
        "AorC": "          "
    },
    "14640": {
        "Name": "Tucker",
        "Number": "75",
        "AorC": "          "
    },
    "14641": {
        "Name": "Bjugstad",
        "Number": "77",
        "AorC": "          "
    },
    "14642": {
        "Name": "Holloway",
        "Number": "81",
        "AorC": "          "
    },
    "14643": {
        "Name": "Mrsic",
        "Number": "86",
        "AorC": "          "
    },
    "14644": {
        "Name": "McIsaac",
        "Number": "87",
        "AorC": "          "
    },
    "14645": {
        "Name": "Buchnevich",
        "Number": "89",
        "AorC": "          "
    },
    "14646": {
        "Name": "Mayich",
        "Number": "95",
        "AorC": "          "
    },
    "14647": {
        "Name": "Bouchard",
        "Number": "2",
        "AorC": "          "
    },
    "14648": {
        "Name": "Frederic",
        "Number": "10",
        "AorC": "          "
    },
    "14649": {
        "Name": "Janmark",
        "Number": "13",
        "AorC": "          "
    },
    "14650": {
        "Name": "Ekholm",
        "Number": "14",
        "AorC": "          "
    },
    "14651": {
        "Name": "Hyman",
        "Number": "18",
        "AorC": "          "
    },
    "14652": {
        "Name": "Henrique",
        "Number": "19",
        "AorC": "          "
    },
    "14653": {
        "Name": "Lazar",
        "Number": "20",
        "AorC": "          "
    },
    "14654": {
        "Name": "Savoie",
        "Number": "22",
        "AorC": "          "
    },
    "14655": {
        "Name": "Nurse",
        "Number": "25",
        "AorC": "          "
    },
    "14656": {
        "Name": "Kulak",
        "Number": "27",
        "AorC": "          "
    },
    "14657": {
        "Name": "Draisaitl",
        "Number": "29",
        "AorC": "          "
    },
    "14658": {
        "Name": "Pickard",
        "Number": "30",
        "AorC": "          "
    },
    "14659": {
        "Name": "Ungar",
        "Number": "32",
        "AorC": "          "
    },
    "14660": {
        "Name": "Leppänen",
        "Number": "37",
        "AorC": "          "
    },
    "14661": {
        "Name": "Kapanen",
        "Number": "42",
        "AorC": "          "
    },
    "14662": {
        "Name": "Philp",
        "Number": "48",
        "AorC": "          "
    },
    "14663": {
        "Name": "Emberson",
        "Number": "49",
        "AorC": "          "
    },
    "14664": {
        "Name": "Stecher",
        "Number": "51",
        "AorC": "          "
    },
    "14665": {
        "Name": "Howard",
        "Number": "53",
        "AorC": "          "
    },
    "14666": {
        "Name": "Nicholl",
        "Number": "56",
        "AorC": "          "
    },
    "14667": {
        "Name": "Carfagna",
        "Number": "73",
        "AorC": "          "
    },
    "14668": {
        "Name": "Skinner",
        "Number": "74",
        "AorC": "          "
    },
    "14669": {
        "Name": "Regula",
        "Number": "75",
        "AorC": "          "
    },
    "14670": {
        "Name": "Tomasek",
        "Number": "86",
        "AorC": "          "
    },
    "14671": {
        "Name": "Mangiapane",
        "Number": "88",
        "AorC": "          "
    },
    "14672": {
        "Name": "Podkolzin",
        "Number": "92",
        "AorC": "          "
    },
    "14673": {
        "Name": "Nugent-Hopkins",
        "Number": "93",
        "AorC": "          "
    },
    "14674": {
        "Name": "Walman",
        "Number": "96",
        "AorC": "          "
    },
    "14675": {
        "Name": "McDavid",
        "Number": "97",
        "AorC": "C         "
    },
    "14676": {
        "Name": "Larsson",
        "Number": "6",
        "AorC": "          "
    },
    "14677": {
        "Name": "Eberle",
        "Number": "7",
        "AorC": "C         "
    },
    "14678": {
        "Name": "Fleury",
        "Number": "8",
        "AorC": "          "
    },
    "14679": {
        "Name": "Stephenson",
        "Number": "9",
        "AorC": "          "
    },
    "14680": {
        "Name": "Beniers",
        "Number": "10",
        "AorC": "          "
    },
    "14681": {
        "Name": "Kartye",
        "Number": "12",
        "AorC": "          "
    },
    "14682": {
        "Name": "Schwartz",
        "Number": "17",
        "AorC": "          "
    },
    "14683": {
        "Name": "McCann",
        "Number": "19",
        "AorC": "          "
    },
    "14684": {
        "Name": "Tolvanen",
        "Number": "20",
        "AorC": "          "
    },
    "14685": {
        "Name": "Oleksiak",
        "Number": "24",
        "AorC": "          "
    },
    "14686": {
        "Name": "Winterton",
        "Number": "26",
        "AorC": "          "
    },
    "14687": {
        "Name": "Marchment",
        "Number": "27",
        "AorC": "          "
    },
    "14688": {
        "Name": "Mahura",
        "Number": "28",
        "AorC": "          "
    },
    "14689": {
        "Name": "Dunn",
        "Number": "29",
        "AorC": "          "
    },
    "14690": {
        "Name": "Murray",
        "Number": "30",
        "AorC": "          "
    },
    "14691": {
        "Name": "Grubauer",
        "Number": "31",
        "AorC": "          "
    },
    "14692": {
        "Name": "Daccord",
        "Number": "35",
        "AorC": "          "
    },
    "14693": {
        "Name": "Nyman",
        "Number": "38",
        "AorC": "          "
    },
    "14694": {
        "Name": "Evans",
        "Number": "41",
        "AorC": "          "
    },
    "14695": {
        "Name": "Wright",
        "Number": "51",
        "AorC": "          "
    },
    "14696": {
        "Name": "Lindgren",
        "Number": "55",
        "AorC": "          "
    },
    "14697": {
        "Name": "Montour",
        "Number": "62",
        "AorC": "          "
    },
    "14698": {
        "Name": "Catton",
        "Number": "77",
        "AorC": "          "
    },
    "14699": {
        "Name": "Kakko",
        "Number": "84",
        "AorC": "          "
    },
    "14700": {
        "Name": "Gaudreau",
        "Number": "89",
        "AorC": "          "
    },
    "14701": {
        "Name": "McCormick",
        "Number": "91",
        "AorC": "          "
    }
}

interface NhlDetailsProps {
  fullWizardData: 
    { jerseyType: string, namebar: "Yes"|"No", size: string, team: string, type: "Official", qty: { itemid: string, sku: string, uofm: string, qty: number, eachPrice: number }[] }
    |
    { jerseyType: string, namebar: "Yes"|"No", size: string, team: string, type: "Personalized", qty: { number: string, name: string, sku: string, uofm: string, qty: number, eachPrice: number, aorc?: string }[] }
    |
    { jerseyType: string, namebar: "Yes"|"No", size: string, team: string, type: "OrderAC", qty: { itemid: string, sku: string, uofm: string, qty: number, eachPrice: number }[] }
  isPrintView?: boolean;
}

const NhlDetails: React.FC<NhlDetailsProps> = ({ fullWizardData, isPrintView = false }) => {
  const typeText = fullWizardData.type === "Official" ? "NHL Official Kits" : fullWizardData.type === "Personalized" ? "NHL Personalized Kits" : "NHL A or C Order Kits";
  const columns = styles.twoColumns;
  const rowStyle = isPrintView
    ? "flex flex-row flex-wrap w-full px-0 py-[0.25em] border-b-[rgb(218,218,218)] border-b border-solid grid grid-cols-[25%_75%] gap-4"
    : styles.lnRow;

  const data:{name:string,value:any}[] = [];

  switch (fullWizardData.type) {
    case "Official":
      data.push(
        { name: "Team", value: teamNameById[fullWizardData.team as keyof typeof teamNameById] },
        { name: "Jersey Type", value: jerseyTypeById[fullWizardData.jerseyType as keyof typeof jerseyTypeById] },
        { name: "Size", value: fullWizardData.size },
        { name: "Namebar", value: fullWizardData.namebar },
      )
      for (let i = 0; i < fullWizardData.qty.length; i++) {
        const playerData = playersById[fullWizardData.qty[i].itemid as keyof typeof playersById];
        data.push(
          { name: "Number and name", value: playerData.Number + " - " + playerData.Name },
          { name: "A or C", value: playerData.AorC.trim() },
          { name: "Quantity", value: fullWizardData.qty[i].qty },
        )
      }
      break;
    case "Personalized":
      data.push(
        { name: "Team", value: teamNameById[fullWizardData.team as keyof typeof teamNameById] },
        { name: "Jersey Type", value: jerseyTypeById[fullWizardData.jerseyType as keyof typeof jerseyTypeById] },
        { name: "Size", value: fullWizardData.size },
        { name: "Namebar", value: fullWizardData.namebar },
      )
      for (let i = 0; i < fullWizardData.qty.length; i++) {
        data.push(
          { name: "Number and name", value: fullWizardData.qty[i].number + " - " + fullWizardData.qty[i].name },
          { name: "A or C", value: fullWizardData.qty[i].aorc?.trim() },
          { name: "Quantity", value: fullWizardData.qty[i].qty },
        )
      }
      break;
    case "OrderAC":
      data.push(
        { name: "Team", value: teamNameById[fullWizardData.team as keyof typeof teamNameById] },
        { name: "Jersey Type", value: jerseyTypeById[fullWizardData.jerseyType as keyof typeof jerseyTypeById] },
        { name: "Size", value: fullWizardData.size },
        { name: "Namebar", value: fullWizardData.namebar },
      )
      for (let i = 0; i < fullWizardData.qty.length; i++) {
        data.push(
          { name: "A or C", value: fullWizardData.qty[i].itemid },
          { name: "Quantity", value: fullWizardData.qty[i].qty },
        )
      }
      break;
  }

  return (
    <>
      <div className={[styles.card, columns, styles.lnCard, isPrintView && "text-sm"].join(' ')}>
        <h3 className={`uppercase text-[#F36E29] font-bold ${!isPrintView ? 'pt-[1.5em] pb-0 px-[1.5em]' : 'mb-4'}`}>Design Details{isPrintView ? ` - ${typeText}` : ""}</h3>

        {/* Design Details */}
        <div className={`${styles.cardBody} ${isPrintView ? "mr-2" : ""}`}>
          {!isPrintView &&
            <div className={rowStyle}>
              <span className={[styles.value, "pb-2 text-lg text-center w-full"].join(' ')}>{typeText}</span>
            </div>
          }
          {data?.length ? data.map(({ name, value }) => {
            const displayValue = value;

            return displayValue ? (
              <div className={rowStyle} key={name}>
                <span className={styles.name}>{`${name}:`}</span>
                <span className={styles.value}>{displayValue}</span>
              </div>
            ) : null;
          }) : null}
        </div>
      </div>
    </>
  );
};

export default NhlDetails;